import request from './request'

export const authAPI = {
  login(data) {
    return request({
      url: '/api/v1/auth/login',
      method: 'post',
      data
    })
  },

  getProfile() {
    return request({
      url: '/api/v1/auth/me',
      method: 'get'
    })
  }
}
